import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, ToastProvider } from '@modulus/ui'
import App from './App'
import { SessionProvider } from './lib/session'
import { startQueueDraining } from './lib/queue'
import './index.css'

// Replays anything written while offline, and keeps replaying on reconnect.
startQueueDraining()

// And this is what makes that queue reachable after a reload with no signal: the
// worker holds the app shell, so a cold open offline gets the app rather than the
// browser's error page. Registered after load so it never competes with the first
// paint, and only in a build — a worker in front of the dev server serves stale
// modules and breaks HMR in ways that look like your own bug.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Offline support is an enhancement. A registration that fails — a private
      // window, a browser with workers disabled — must not surface as an error.
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <BrowserRouter>
          <SessionProvider>
            <App />
          </SessionProvider>
        </BrowserRouter>
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
